import { useTranslation } from 'react-i18next';
import { formatToDate } from 'utils/formatToDate';

import { DocumentModel } from 'api/documents/documents.model';
import CompositionRow from 'components/CompositionRow/CompositionRow';
import Detail from 'components/Detail';
import SectionTitle from 'components/SectionTitle';
import SubTitle from 'components/SubTitle';
import useCertificateHelper from 'hooks/useCertificateHelper';
import {
  ADDITIONAL_DETAILS,
  CertificateDetailsModel,
  NESTED_DETAILS,
  TEST_RESULTS_DETAILS,
} from 'models/certificate.model';

import RelatedDocument from '../RelatedDocument';
import Template from '../Template';

const BatteryCellsTestResults = ({
  additionalDetails = {} as CertificateDetailsModel,
  ...document
}: DocumentModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();
  const { getLabel } = useCertificateHelper();

  return (
    <Template
      document={{
        additionalDetails,
        ...document,
      }}
      rigthCard={
        <>
          <Detail
            label={getLabel(ADDITIONAL_DETAILS.TEST_DATE)}
            value={formatToDate(additionalDetails[ADDITIONAL_DETAILS.TEST_DATE])}
          />
          <Detail
            label={t('document.dateOfPublication')}
            value={formatToDate(document.publicationDate)}
          />
          <Detail
            label={getLabel(NESTED_DETAILS.BATTERY_CELL_MODEL)}
            value={additionalDetails[NESTED_DETAILS.BATTERY_CELL_MODEL]}
          />
          <RelatedDocument
            relatedDocumentProductId={additionalDetails[NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER]}
          >
            <Detail
              label={getLabel(NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER)}
              value={additionalDetails[NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER]}
            />
          </RelatedDocument>
        </>
      }
    >
      <SectionTitle>{getLabel('specification')}</SectionTitle>
      <SubTitle>{getLabel(ADDITIONAL_DETAILS.TEST_RESULTS)}</SubTitle>
      <CompositionRow<TEST_RESULTS_DETAILS>
        composition={additionalDetails[ADDITIONAL_DETAILS.TEST_RESULTS]}
        labels={[
          TEST_RESULTS_DETAILS.NOMINAL_CAPACITY,
          TEST_RESULTS_DETAILS.AVERAGE_NOMINAL_CAPACITY,
          TEST_RESULTS_DETAILS.NOMINAL_VOLTAGE,
          TEST_RESULTS_DETAILS.VOLTAGE,
          TEST_RESULTS_DETAILS.ENERGY,
        ]}
      />
    </Template>
  );
};

export default BatteryCellsTestResults;
